
import { getCompanyProfiles, profileGetByProfileId } from "~/utils/api";

const FALLBACK_AVATAR = require('~/assets/icons/person-icon.png');

export default {
  name: 'SideBar',
  components: {
  },
  props: {
    activePage: String
  },
  computed: {
    dragOptions() {
        return {
            
        };
    }
    },
    watch: {
        '$auth.user': {
            deep: true,
            immediate: true,
            handler() {
                this.hydrateSidebarUser();
                this.loadModuleAccess();
            }
        }
  },
    data() {
        return {
            profilePicture: '',
            userName: '',
            multipleProfiles: '',
            hasOrderModule: false,
            loading: false
        }
    },
        async mounted() {
            await this.hydrateSidebarUser();
            await this.loadModuleAccess();
        },
  methods: {
            async hydrateSidebarUser() {
                const user = this.$auth?.user;
                if (!user) {
                    this.profilePicture = FALLBACK_AVATAR;
                    this.userName = '';
                    this.multipleProfiles = 0;
                    return;
                }

                this.profilePicture = user.profilePicture || user.profileImage || FALLBACK_AVATAR;
                this.userName = `${user.firstname || ''} ${user.lastname || ''}`.trim();

                const activeProfile =
                    this.$auth?.$storage?.getUniversal?.('activeProfile') ||
                    this.$auth?.$storage?.getState?.('activeProfile') ||
                    this.$store?.state?.user?.activeProfile ||
                    null;

                const profileId = user.profileId || user.profile_id || activeProfile?.profile_id;
                if (profileId && (!user.profilePicture && !user.profileImage)) {
                    try {
                        const profile = await profileGetByProfileId(profileId);
                        if (profile?.profile_picture) {
                            this.profilePicture = profile.profile_picture;
                        }
                    } catch (_) {
                        // Keep fallback avatar on profile fetch failure.
                    }
                }

                if (user.uid) {
                    try {
                        const profiles = await getCompanyProfiles(user.uid);
                        this.multipleProfiles = Array.isArray(profiles) ? profiles.length : 0;
                    } catch (_) {
                        this.multipleProfiles = 0;
                    }
                } else {
                    this.multipleProfiles = 0;
                }
            },
      async loadModuleAccess() {
            const companyId = this.$auth?.user?.companyId;
            if (!companyId) {
                this.hasOrderModule = false;
                return;
            }

            try {
                const response = await this.$api.get(`/companies/module/order/read?companyId=${companyId}`);
                this.hasOrderModule = response.data.has_order_module === true && response.data.has_project_module === true;
            } catch (_) {
                this.hasOrderModule = false;
            }
      },
      async logOut(){
        await this.$auth.logout();
        this.$router.push('/login');
      },
      switchProfile(){
        this.$router.push('/login/profielen');
      },
      startLoading(){
        this.loading = true;
        this.$emit("disable");
      },
      endLoading(){
        this.loading = false;
        this.$emit("enable");
    },
      activateTab(i){
        this.selected = i;
    },
  }
}
